import React, {PureComponent} from 'react';

import {Callout, Classes, Overlay} from "@blueprintjs/core";
import {Link} from "react-router-dom";

export default class SMSSentModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        contacts: this.props.contacts,
        costEstimate: this.props.costEstimate === '0.0000' || this.props.costEstimate === '' ? '' : Number(this.props.costEstimate) < 0.5 ? 0.5 : Number(this.props.costEstimate),
        topUpAmount: this.props.topUpAmount,
        remainingCredits: this.props.remainingCredits,
        workspaceBalance: this.props.workspaceBalance,
        vatPercent: this.props.vatPercent
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {

        this.setState({

            contacts: this.props.contacts,
            //costEstimate: this.props.costEstimate === '0.0000' || this.props.costEstimate === '' ? '' : Number(this.props.costEstimate) < 0.6 ? 0.6 : Number(this.props.costEstimate)
        })
        //console.log('number estimate1: ', this.state.costEstimate)
    }

    goToCampaignPerformance = () => {
        localStorage.removeItem('selected_main_type')
        this.props.handleClose()
        this.props.history.push('/my-campaigns/sms')
    }
    componentDidUpdate = async () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            await this.setState({
                overlayIsOpen: this.props.showModal,
                contacts: this.props.contacts,
                costEstimate: this.props.costEstimate, //=== '0.0000' || this.props.costEstimate === '' ? '' : Number(this.props.costEstimate) < 0.6 ? 0.6 : Number(this.props.costEstimate),
                topUpAmount: this.props.topUpAmount,
                remainingCredits: this.props.remainingCredits,
                workspaceBalance: this.props.workspaceBalance,
                vatPercent: this.props.vatPercent,
                workspaceCredits: this.props.workspaceCredits
            })
            //console.log('number estimate2: ', this.state.costEstimate)

        }
    }

    setTestNumber = (e) => {
        this.setState({testNumber: e.target.value})
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {/*<div className="modal-field" id='sms-sent-modal'*/}
                {/*     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>*/}
                {/*    <div className="onboarding-panel viber-modal-container">*/}
                {/*        <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>*/}

                {/*        <h1 className='text-green text-center'>Your SMS has been successfully sent!</h1>*/}

                {/*    </div>*/}
                {/*</div>*/}
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={() => {
                        this.props.handleClose()
                    }}><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel post-reach">


                        <React.Fragment>
                            <p className=" modal-title text-center m-m-b" style={{fontSize: "30px"}}>
                                Your SMS campaign has been dispatched to:
                            </p>


                            <React.Fragment>
                                <div className="section-content text-center ">
                                    <p className="letter text-bold">
                                        {this.props.contacts}
                                        <br></br>
                                        <span>{this.props.contacts === 1 ? 'Contact' : 'Contacts'}</span>
                                    </p>
                                </div>
                                {
                                    //UPDATED
                                    Number(this.state.costEstimate) === 0 ?
                                        //FREE CASE
                                        <Callout className='estimate-cost-callout'>


                                            <span className='flex-row justify-content-space'>
                                                <div>
                                                    <div className='flex-row estimated-cost-container'>
                                                        Estimated Cost:
                                                    </div>
                                                    {/*<span*/}
                                                    {/*    className='grey-text'>{this.state.freeMessagesInitial - this.state.freeMessagesRemaining + ' '}*/}
                                                    {/*    free SMS will be used</span>*/}
                                                </div>
                                                <span
                                                    className='cost-estimate-value cost-free'>FREE</span>
                                            </span>

                                        </Callout>

                                        :

                                        // NOT FREE CASE
                                        <React.Fragment>
                                            <Callout className='estimate-cost-callout viber-total-cost'>

                                                <span className='flex-row justify-content-space'>

                                                    <div className='flex-row estimated-cost-container'>
                                                        Total Cost
                                                    </div>
                                                    {/*{this.state.freeMessagesInitial !== 0 ?*/}
                                                    {/*    <span*/}
                                                    {/*        className='grey-text free-messages-cost-estimate'>{this.state.freeMessagesInitial - this.state.freeMessagesRemaining + ' '}*/}
                                                    {/*        free SMS will be used</span>*/}
                                                    {/*    :*/}
                                                    {/*    ''*/}
                                                    {/*}*/}
                                                    <span
                                                        className='cost-estimate-value viber-cost-estimate-value text-bold'>

                                                        {

                                                            this.state.costEstimate + ' credits'
                                                        }
                                                        {/*}*/}
                                                    </span>

                                                </span>
                                                <hr/>
                                                <span className='flex-row justify-content-space'>
                                                    <div>Available Workspace Credits</div>
                                                    <div>
                                                        {Number(this.state.workspaceCredits).toFixed(2)} credits

                                                    </div>
                                                </span>
                                                <span className='flex-row justify-content-space'>
                                                    <div>
                                                        Top-up Required
                                                    </div>
                                                    <div className='blue-text'>
                                                        {this.state.topUpAmount !== '' ?
                                                            Number(this.state.topUpAmount).toFixed(2) + ' credits'

                                                            : '0.00 credits'}

                                                    </div>
                                                </span>
                                                {/*<span className='flex-row justify-content-space'>*/}
                                                {/*    <div>*/}
                                                {/*        Top-up Amount*/}
                                                {/*    </div>*/}
                                                {/*    <div className='blue-text'>*/}
                                                {/*        $ {this.state.topUpAmount !== '' ?*/}
                                                {/*        this.state.vatPercent !== 0 && this.state.vatPercent !== '' ?*/}
                                                {/*            (Number(this.state.topUpAmount) + Number((this.state.topUpAmount / 100) * this.state.vatPercent)).toFixed(2) :*/}
                                                {/*            Number(this.state.topUpAmount).toFixed(2)*/}

                                                {/*        : '0.00'}*/}
                                                {/*        {this.state.vatPercent !== 0 && this.state.vatPercent !== '' && this.state.topUpAmount !== '' && this.state.topUpAmount !== 0 ?*/}
                                                {/*            <span className='vat-included'>*/}
                                                {/*                (VAT*/}
                                                {/*                included:${Number((this.state.topUpAmount / 100) * this.state.vatPercent).toFixed(2)})*/}
                                                {/*            </span>*/}
                                                {/*            : ''}*/}
                                                {/*    </div>*/}
                                                {/*</span>*/}
                                            </Callout>

                                            {this.state.topUpDisclaimer ?
                                                <p className='text-right minimal-charge top-up-disclaimer'>
                                                    Minimal top-up amount is 1000 credits
                                                </p>
                                                :
                                                ''
                                            }

                                            <div id='sms'
                                                 className='new-balance-viber display-flex justify-content-space'>
                                                <span>
                                                    Credits remaining after this campaign
                                                </span>
                                                <span className='text-bold'>
                                                    {Number(this.state.remainingCredits).toFixed(2)
                                                        // ?
                                                        // '0.00.'
                                                        // :
                                                        // this.state.remainingCredits !== '' ? this.state.costEstimate <
                                                        // 0.01 && this.state.remainingCredits <
                                                        // 0.01 ? (this.state.remainingCredits).toFixed(4) :
                                                        //     (this.state.remainingCredits).toFixed(2) : ''
                                                    }
                                                </span>
                                            </div>
                                        </React.Fragment>
                                }
                                <div className="row reach-modal-performance-msg text-center">
                                    Please visit <Link onClick={() => {
                                    this.props.handleClose()
                                }}
                                                       to='/my-campaigns/sms'>campaign
                                    performance</Link> page for detailed
                                    analytics of this campaign.
                                </div>
                            </React.Fragment>

                        </React.Fragment>
                    </div>
                    <div className="m-lg-t flex-direction-row justify-content-space">
                        <button className='btn-white'
                                onClick={this.goToCampaignPerformance}>
                            Go to My Campaigns
                        </button>
                        <button className='btn-action'
                                onClick={() => {
                                    this.props.handleClose()
                                }}>
                            Start a new campaign
                        </button>
                    </div>
                </div>
            </Overlay>
        )
    }
}